import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Container, Table } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import SupportedDatasources from '../../constants/datasources';
import DataObject from '../../components/DataObject';
import BigQuery from '../../components/connectors/BigQuery';
import RDBMS from '../../components/connectors/RDBMS';
import Presto from '../../components/connectors/Presto';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DatasourcesScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);
        this.state = {
            selectedDatabaseId: this.props.match.params.database_id || null,
            datasources: [],
            isGrantingPermission: queries.is_granting_permission || false,
            userId: queries.user_id || 0,
            isAddNew: false,
            createNewDatasourceType: '',
        }
    }
    componentWillMount() {
        this.getDatasources();
    }
    componentDidMount = () => {
    }
    getDatasources() {
        const {  isGrantingPermission, userId } = this.state;
        let uri = `datasources`;

        if (userId && isGrantingPermission) {
            uri = `${uri}?permission_user_id=${userId}`;
        }
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                this.setState({ datasources: response.datasources });
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { datasources, isAddNew, createNewDatasourceType } = this.state;
        
        let newDatasourceObject = null;
        switch(createNewDatasourceType) {
            case 'bigquery':
                newDatasourceObject = <BigQuery isCreateNew onDatasourceUpdated={() => this.getDatasources()} />
            case 'postgres':
                newDatasourceObject = <RDBMS datasourceType={createNewDatasourceType} isCreateNew onDatasourceUpdated={() => this.getDatasources()} />
            case 'mysql':
                newDatasourceObject = <RDBMS datasourceType={createNewDatasourceType} isCreateNew onDatasourceUpdated={() => this.getDatasources()} />
            case 'presto':
                newDatasourceObject = <Presto datasourceType={createNewDatasourceType} isCreateNew onDatasourceUpdated={() => this.getDatasources()} />
            default:
                // code block
        }
        return (
            <div style={{ marginTop: 12 }}>
                <Row>
                    <Col xs={12}>
                        <Button
                            color="primary"
                            onClick={() => this.setState({ isAddNew: !isAddNew })}
                        >
                            Add new datasource
                        </Button>
                    </Col>
                </Row>
                {isAddNew &&
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Input
                                    type="select"
                                    onChange={(e) => this.setState({ createNewDatasourceType: e.target.value })}
                                >
                                    <option value=''>-- Select a datasource to add--</option>
                                    {SupportedDatasources.map(supportedDatasource =>
                                      <option value={supportedDatasource.datasource_type}>
                                          {supportedDatasource.datasource_type_name}
                                      </option>  
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                }
                {createNewDatasourceType &&
                    <Row>
                        <Col xs={12}>
                            {newDatasourceObject}
                        </Col>
                    </Row>
                }
                <Row>
                    {datasources.map(datasource => 
                        <Col xs={12} sm={6} md={4} key={datasource.id} style={{padding: 12}}>
                            <DataObject dataObject={datasource} />
                        </Col> 
                    )}
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Datasources/index.js